var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIconHighlighted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.5833V16.5H0V15.5833L1.83333 13.75V8.25C1.83333 5.40833 3.69417 2.90583 6.41667 2.09917V1.83333C6.41667 1.3471 6.60982 0.880787 6.95364 0.536971C7.29745 0.193154 7.76377 0 8.25 0C8.73623 0 9.20255 0.193154 9.54636 0.536971C9.89018 0.880787 10.0833 1.3471 10.0833 1.83333V2.09917C12.8058 2.90583 14.6667 5.40833 14.6667 8.25V13.75L16.5 15.5833ZM10.0833 17.4167C10.0833 17.9029 9.89018 18.3692 9.54636 18.713C9.20255 19.0568 8.73623 19.25 8.25 19.25C7.76377 19.25 7.29745 19.0568 6.95364 18.713C6.60982 18.3692 6.41667 17.9029 6.41667 17.4167",
    fill: "#3578FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIconHighlighted);
export default __webpack_public_path__ + "static/media/BellIcon-Highlighted.cf316ca157666281b35cd9ffcc5e9df0.svg";
export { ForwardRef as ReactComponent };